<div class="row">
    <span class="groupTitle"> {{groupValue}}</span>
    <div *ngFor="let column of aggFuncColumns" class="aggFun" [style.width.px]="column.width"
        [style.left.px]="column.left">
        {{ column.value }}
    </div>
</div>